<template>
  <ion-page id="send-delete-account-page">
    <ion-content>
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
           :style="styleOneFrame" :key="menuTrigger">
  
        <ion-item>
          <h3>{{ t("If you wish to have your Chessvis and Verbal Chess account deleted, the button below will send you an email which you can then reply to. Upon receipt of your reply, I will delete your account.") }}"</h3>
        </ion-item>
        <ion-item>
          <h3>{{ message1 }}</h3>
        </ion-item>
        <div v-if="showEmail">
          <ion-item>
            <h4>{{ t("For") }}: {{ email }}</h4>
          </ion-item>
          <ion-item>
            <ion-button expand="full" size="large" @click="doSendDeleteEmail()" >{{ t("Send Delete Account Request Email") }}</ion-button>
          </ion-item>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>

import { IonLabel,IonCheckbox, IonGrid,IonRow,IonCol,IonButton,IonItem,IonInput,IonPage, IonContent , modalController } from '@ionic/vue';

import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
import { t } from '@/composables/translateText.js'

import { ref, watch } from 'vue';
import { useGetData } from '@/composables/getData.js'
import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';
import { doStartupCheck } from '@/composables/startupCheck.js'
import { availableWidthHeight }  from '@/composables/screenSize'

const connectionStore = useConnectionStore()

const isDark = ref(connectionStore.getDarkmode != "" && connectionStore.getDarkmode != "light")
const menuTrigger = ref(0)

const windowSizeStore = useWindowSizeStore()
const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] })

const emailStorage = connectionStore.getEmailAddress

const email = ref( (emailStorage == null) ? "" : emailStorage)

const message1 = ref("")
const showEmail= ref(true)

const styleOneFrame = ref({
   position : "absolute",
   "overflow-y" : "scroll",
   top : "0px",
   left : "100px",
   width: "100px",
   height : "100px"
 })

 updateWidthHeights()

const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** logoff new window size",windowSizeRef.value)
    menuTrigger.value++
    updateWidthHeights()
  })

function updateWidthHeights() {

  const availableSpace = availableWidthHeight()
  const oneframePositionTop = availableSpace.topIndent
  const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
  const oneframeHeight = availableSpace.height - oneframePositionTop + availableSpace.topIndent
  const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

  styleOneFrame.value.height = oneframeHeight + "px"
  styleOneFrame.value.width = oneframeWidth + "px"
  styleOneFrame.value.top = oneframePositionTop + "px"
  styleOneFrame.value.left = oneframePositionLeft + "px"

  //console.log("frame size",styleOneFrame.value)
}

function doSendDeleteEmail () {
  message1.value = t("Sending Delete Request Email") + "..."
  var formData = { junk : "blah" }
  useGetData("send9_delete_request_email.php", formData, processJsonResponse)
}

function processJsonResponse (json) {
  //console.log(" in email verification callback",json)
  if (json.hasOwnProperty('error')) {
    openErrorModal(json['programRun'],json['error'])
    return;
  }

  message1.value = json['mess']
}

</script>

<style scoped>

.item{
  margin:10px auto;
}

</style>